import { render } from "./ReviewTile.vue?vue&type=template&id=7df07af4&scoped=true"
import script from "./ReviewTile.vue?vue&type=script&lang=js"
export * from "./ReviewTile.vue?vue&type=script&lang=js"

import "./ReviewTile.vue?vue&type=style&index=0&id=7df07af4&scoped=true&lang=css"

import exportComponent from "/Users/felix/dev/projects/protfolio/schillerando-demo/schillerando-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7df07af4"]])

export default __exports__